export const SupportedLanguages = {
  English: 'en',
  French: 'fr',
  Spanish: 'es',
};

export type SupportedLanguage = (typeof SupportedLanguages)[keyof typeof SupportedLanguages];
